import { querySelector, querySelectorAll } from '../functions/querySelectors';
import { setListenersFromSelector } from '../functions/listeners';
import { DEFAULT_TRANSITION_TIME } from '../config/main';
import setCookie from '../functions/setCookie';

const ROOT_CLASS = 'c-hello-bars';
const ROOT_WRAPPER_CLASS = 'c-hello-bars__wrapper';
const BAR_CLASS = 'c-hello-bar';
const BAR_SHOW_CLASS = 'c-hello-bar--show';
const COUNT_ATTR = 'data-count';
const DELAY_ATTR = 'data-delay';
const CLOSE_CLASS = 'js-hello-bar-close';
const SHOW_ATTR = 'data-show';
const COOKIE_NAME_ATTR = 'data-alert-name';
const HIDING_CLASS = 'is-hiding';

var itemsCount = 1;
var activeItem = 0;
var bars = [];
var rootElement = null;
var rootWrapperElement = null;

let moveItems = function() {
  let moveItem = activeItem + 1;
  let first = false;

  if (moveItem > itemsCount - 1) {
    moveItem = 0;
    first = true;
  }

  bars[moveItem].classList.add(BAR_SHOW_CLASS);
  bars[moveItem].style.left = (first ? `${(itemsCount - 1) * 100}%` : '-100%');
  bars[moveItem].setAttribute(SHOW_ATTR, 1);

  setTimeout(() => {
    bars[activeItem].classList.remove(BAR_SHOW_CLASS);
    bars[moveItem].style.removeProperty('left');
    rootWrapperElement.style.transform = first ? 'none' : `translateX(-${(activeItem + 1) * 100}%)`;
    activeItem = moveItem;

    setTimeout(() => {
      moveItems();
    }, parseInt(bars[activeItem].getAttribute(DELAY_ATTR), 10) * 1000);
  }, DEFAULT_TRANSITION_TIME);
};

let hideBars = function() {
  bars.forEach((bar) => {
    if (typeof bar.getAttribute(SHOW_ATTR) === 'string') {
      setCookie(bar.getAttribute(COOKIE_NAME_ATTR), 1, 3650, false);
    }
    else {
      setCookie(bar.getAttribute(COOKIE_NAME_ATTR), 1, 0, true);
    }
  });
};

let closeClick = function(event) {
  event.preventDefault();
  event.stopPropagation();

  hideBars();
  rootElement.classList.add(HIDING_CLASS);

  setTimeout(() => {
    rootElement.remove();
  }, DEFAULT_TRANSITION_TIME);
};

let setClosers = function() {
  setListenersFromSelector(
    `.${CLOSE_CLASS}`,
    `i-${CLOSE_CLASS}`,
    closeClick
  );
};

export default function() {
  rootElement = querySelector(`.${ROOT_CLASS}`);
  rootWrapperElement = querySelector(`.${ROOT_WRAPPER_CLASS}`, rootElement);

  if (rootElement) {
    let count = parseInt(rootElement.getAttribute(COUNT_ATTR), 10);
    bars = querySelectorAll(`.${BAR_CLASS}`, rootElement);

    if (count > 1) {
      itemsCount = count;

      bars[0].setAttribute(SHOW_ATTR, 1);

      setTimeout(() => {
        moveItems();
      }, parseInt(bars[0].getAttribute(DELAY_ATTR), 10) * 1000);
    }
    else {
      bars[0].setAttribute(SHOW_ATTR, 1);
    }

    setClosers();
  }
}
